import { toast } from 'react-hot-toast';
import { useMutation } from 'react-query';
import { useClient } from '../../../api/api-client';
import { isPlayGroundMode } from '../../../utils/CookieToken';

export const mediaUploadKey = ['upload_complaint_media'];

export function useUploadFile(updateImageGrid, setIsUploading) {
  const client = useClient();
  return useMutation({
    mutationKey: [...mediaUploadKey, 'uploads'],
    mutationFn: (data) => {
      client(
        `${
          isPlayGroundMode
            ? 'playground/complaint_media/upload'
            : 'lifeline_apis/complaint_media/upload'
        }`,
        {
          data,
          isFile: true,
        },
      )
        .then((res) => {
          setIsUploading(false);
          if (res?.isError) return toast.error(res?.message);
          updateImageGrid(res?.complaint_media);
        })
        .catch((err) => {
          setIsUploading(false);
          return toast.error(err?.message);
        });
    },
    meta: {
      hideAlert: true,
    },
  });
}
